const LSK = {
  /* eslint sort-keys: "error" */
  APP_VERSION: 'appVersion',
  CCM_DASHBOARD_NOTIFICATIONS: 'cloud-cost-management/notifications',
  CCM_DISMISSED_ACCOUNT_ERROR: 'cloud-cost-management/notifications/dismissedAccountErrors',
  CCM_DISMISSED_ACCOUNT_IMPORT: 'cloud-cost-management/notifications/dismissedAccountImports',
  CCM_GRAPHS_STATE: 'cloud-cost-management/graphs',
  CCM_GROUP_BY_NOTIFICATIONS: 'cloud-cost-management/group-by/notifications',
  CCM_SIDEBAR_COLLAPSED: 'cloud-cost-management/sidebar/collapsed',
  CCM_TAGS_NOTIFICATIONS: 'cloud-cost-management/tags/notifications',
  DEV_SHOW_DEV_THINGS: 'showDevThings',
  DEV_SHOW_FEATURE: 'showDevFeature',
  ENVIRONMENT: 'environment',
  IMPERSONATION_ORIGINAL_JWT: 'impersonation/originalJwt',
  // NOTE I decided not to touch vuex/ prefixes
  JWT: 'vuex/auth/jwt',
  LAST_USED_SOCIAL_PROVIDER: 'lastUsedSocialProvider',
  OIDC_AUTHORIZATION_CODE: 'custom_oidc_authorization_code',
  OIDC_CODE_VERIFIER: 'oidc_code_verifier',
  ORGANIZATION: 'vuex/organization/detail',
  OWNS: 'vuex/auth/owns',
  PROFILE: 'vuex/user/profile',
  REDIRECT_ROUTE: 'vuex/auth/afterLogIn/redirectRoute',
  SIGNUP_EMAIL: 'signupEmail',
  SSO_ERROR: 'sso_error',
  SSO_TOKEN_GITHUB: 'github_id_token',
  STACKFORMS_FORM_VALIDATION: 'stackforms/form-validation-v2',
}

window.LSK = LSK

export default LSK
